import { Controller } from '@hotwired/stimulus';

import { Modal } from 'bootstrap';

export default class HealthcheckController extends Controller {
  static values = {
    url: String
  };

  connect() {
    const modal = new Modal(this.element);

    this.failedCount = 0;

    this.timer = setInterval(async () => {
      try {
        const res = await fetch(this.urlValue);

        if (!res.ok) throw new Error(res.statusText);

        this.failedCount = 0;

        modal.hide();
      } catch (e) {
        console.error(e);

        this.failedCount += 1;

        if (this.failedCount >= 5) {
          modal.show();
        }
      }
    }, 5_000);
  }

  disconnect() {
    clearInterval(this.timer);
  }
}
